<template>
  <div ref="root" :style="rootStyle">
    <div :style="fixedStyle">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Affix',
  props: {
    // 滚动容器的类名，不指定的时候滚动容器为 document.body
    scrollEl: String,
    top: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      isFixed: false,
      scrollContainer: null,
      width: 0,
      height: 0,
    };
  },
  computed: {
    rootStyle() {
      return {
        width: this.isFixed ? `${this.width}px` : '',
        height: this.isFixed ? `${this.height}px` : '',
      };
    },
    fixedStyle() {
      return {
        width: this.isFixed ? `${this.width}px` : '',
        height: this.isFixed ? `${this.height}px` : '',
        position: this.isFixed ? 'fixed' : '',
        top: this.isFixed ? `${this.top}px` : '',
        zIndex: this.isFixed ? `${this.zIndex}` : '',
      };
    },
  },
  mounted() {
    if (this.scrollEl) {
      this.scrollContainer = document.querySelector(this.scrollEl);
      if (!this.scrollContainer) {
        throw new Error(`scrollEl is not exist: ${this.scrollEl}`);
      }
    } else {
      this.scrollContainer = window;
    }

    this.scrollContainer.addEventListener('scroll', this.onScroll);
    this.$once('hook:beforeDestroy', () => {
      this.scrollContainer.removeEventListener('scroll', this.onScroll);
    });
  },
  methods: {
    onScroll() {
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if( clientHeight < 768 ){
        this.isFixed = false;
      }else{
        const rootRect = this.$refs.root.getBoundingClientRect();
        this.isFixed = rootRect.top <= this.top;
        this.width = rootRect.width;
        this.height = rootRect.height;
      }
      

      this.$emit('onScroll', { isFixed: this.isFixed });
    },
  },
};
</script>
